import React__default, { forwardRef, useRef } from 'react';
import { StyledCode } from './styles.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Code = /*#__PURE__*/forwardRef(({
  children,
  sx: sxProp,
  testId,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(StyledCode, _extends({
    sx: sxProp,
    "data-testid": testId ? `${testId}-code` : undefined,
    ref: innerRef
  }, props), children);
});
Code.displayName = 'Code';
var Code$1 = Code;

export { Code$1 as default };
